import React, { Component } from 'react';
import { withRouter } from 'react-router'
import classNames from 'classnames';
import SpinnerDots from '../../components/spinner/dots';
import withAuthProvider from '../../hoc/withAuthProvider';
import withFetch from '../../hoc/withFetch';
//import { WP_API_URL } from '../../config';
import Post from '../../components/post';
import Breadcrumb from '../../components/breadcrumb';
import { REACT_APP_API_BASE } from '../../config';


class BlogItem extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: null,
            isLoading: true
        }
    }

    async requestInitialData(routes) {
        
        
        try {
            const endpoint = `${REACT_APP_API_BASE}/online/news/${routes.params.slug}`;
            
            
            const res = await this.props.fetch(endpoint);
            if (!res.ok) {
                const err500 = new Error(res.statusText);
                err500.status = 500;
                throw err500;
            }

            const data = await res.json();
            return data;
            /*if (wpData.length === 0) {
                const err404 = new Error('Not found');
                err404.status = 404;
                throw err404;
            } */   

            //return wpData[0];
        } catch (err) {
            throw err;
        }
    }

    getImageSrc(props) {
        if (props.images && props.images.length > 0) {
            const img = props.images[0];
            return {
                src: img.filePath,
                alt: props.header
            }
        }

        return null;
    }

    async componentDidUpdate(prevProps, prevState) {
        if (!this.props.isAuthenticated) return;

       
        const { match } = this.props;

        if (this.state.data) return;

        const data = await this.requestInitialData(match);

        this.setState({
            data,
            isLoading: false
        });
    }
    
    render() {
        return (
            <div className={classNames({
                'post-outer': true,
                'post-outer--is-loading': this.state.isLoading
            })}>
                {this.state.data &&
                    <>
                        <Breadcrumb url="/news" link_text="Alla nyheter" />
                        <Post image={this.getImageSrc(this.state.data)} 
                              heading={this.state.data.header}
                              preambleBlock={this.state.data.ingress} 
                              postBlocks={this.state.data.body} {...this.state.data} 
                              fetch={this.props.fetch} />
                    </>
                }  
                <SpinnerDots />              
            </div>
        );
    } 
}

export default withAuthProvider(withFetch(withRouter(BlogItem)));


